import { PageIcon } from "entities/pages/types";
import { ChangeEvent, Dispatch, ReactNode, SetStateAction } from "react";
import { InputHookResult } from "shared/hooks/useInputState";
import { Translations } from "shared/types/languages";

export type PageDetailsType = {
  selectedTab: PageDetailsTabs;
  setSelectedTab: Dispatch<SetStateAction<PageDetailsTabs>>;
  translations?: Translations;
  setTranslations: Dispatch<SetStateAction<Translations | undefined>>;
  isLoading: boolean;
  isSubmitting: boolean;
  pageName?: InputHookResult;
  pageWebTitle?: InputHookResult;
  pageDescription?: InputHookResult;
  showInBurgerMenu: boolean;
  setShowInBurgerMenu: Dispatch<SetStateAction<boolean>>;
  showInDesktopHeaderMenu: boolean;
  setShowInDesktopHeaderMenu: Dispatch<SetStateAction<boolean>>;
  showInMobileBurgerMenuQuickLinks: boolean;
  setShowInMobileBurgerMenuQuickLinks: Dispatch<SetStateAction<boolean>>;
  errors: string;
  setErrors: Dispatch<SetStateAction<string>>;
  disabled: boolean;
  onChangePageName: (e: ChangeEvent<HTMLInputElement>) => void;
  onClosePageDetails: () => void;
  handleSaveDraft: () => void;
  handleSaveActive: () => void;
  handleSaveTranslations: () => void;
  hasSearch: boolean;
  setHasSearch: Dispatch<SetStateAction<boolean>>;
  icon: PageIcon | null;
  setIcon: Dispatch<SetStateAction<PageIcon | null>>;
};

export type PageDetailsProviderProps = {
  children: ReactNode;
};

export enum PageDetailsTabs {
  General,
  Translations,
}

export enum ManagedTranslations {
  PageTitle = "Page title",
  PageWebTitle = "Page web title",
}
